import { workflowToCategoryStatusMap } from './categoryConsts'

function formatCategoryForDisplay(category, workflows) {
  const updatedCategory = {
    ...category
  }
  const workflow = workflows.find(w => w.categoryId === updatedCategory.id)
  if (workflow && workflow.status === 'PENDING' && Object.keys(workflowToCategoryStatusMap).includes(workflow.type)) {
    updatedCategory.status = workflowToCategoryStatusMap[workflow.type]
    updatedCategory.pendingWorkflowId = workflow.workflowId
  }
  return updatedCategory
}

function formatCategoriesForDisplay(categories, workflows) {
  const categoriesToUpdate = JSON.parse(JSON.stringify(categories))
  const updatedCategories = categoriesToUpdate.map(c => formatCategoryForDisplay(c, workflows))
  return updatedCategories
}

export { formatCategoryForDisplay, formatCategoriesForDisplay }
